package dev.iad.portfoliowebsite.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import dev.iad.portfoliowebsite.pagescomponents.index.IndexPageContent

@Page
@Composable
fun IndexPage() {
    IndexPageContent()
}
